'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickedViralLink = exports.clickedForUserDescription = exports.toggleOpen = exports.setMockWidgetData = exports.receivedWidgetData = exports.requestedWidgetFailed = exports.requestedWidget = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchWidget = fetchWidget;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Responder = require('conversations-schema/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _MessageFactory = require('conversations-schema/factories/MessageFactory');

var _color = require('conversations-core/utils/color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var requestedWidget = exports.requestedWidget = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_WIDGET_DATA);

var requestedWidgetFailed = exports.requestedWidgetFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_WIDGET_DATA_FAILED, function (id, error) {
  return {
    id: id,
    error: error
  };
});

var receivedWidgetData = exports.receivedWidgetData = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (widgetData) {
  var rawMessageData = widgetData.message,
      rawResponderData = widgetData.responder,
      rawResponders = widgetData.responders,
      accentColor = widgetData.accentColor,
      otherAttributes = _objectWithoutProperties(widgetData, ['message', 'responder', 'responders', 'accentColor']);

  var message = (0, _MessageFactory.buildWelcomeMessage)(rawMessageData);
  var responder = (0, _Responder2.default)(rawResponderData);
  var responders = (0, _immutable.List)(rawResponders).map(function (rawResponder) {
    return (0, _Responder2.default)(rawResponder);
  });
  var coloring = (0, _color.buildColorRecord)(accentColor);

  return (0, _WidgetData2.default)(_extends({}, otherAttributes, {
    message: message,
    responder: responder,
    responders: responders,
    coloring: coloring
  }));
});

var setMockWidgetData = exports.setMockWidgetData = (0, _reduxActions.createAction)(_ActionTypes2.default.SET_MOCK_WIDGET_DATA, function (user) {
  return { user: user };
});

var toggleOpen = exports.toggleOpen = (0, _reduxActions.createAction)(_ActionTypes2.default.TOGGLE_OPEN, function (isOpened) {
  return {
    isOpened: isOpened
  };
});

var clickedForUserDescription = exports.clickedForUserDescription = (0, _reduxActions.createAction)(_ActionTypes2.default.CLICKED_FOR_USER_DESCRIPTION);
var clickedViralLink = exports.clickedViralLink = (0, _reduxActions.createAction)(_ActionTypes2.default.CLICK_VIRAL_LINK);

function fetchWidget(id, messagesUtk, hubspotUtk) {
  return function (dispatch) {
    dispatch(requestedWidget());
    (0, _MessagesClient.fetchWidgetInfo)(id, messagesUtk, hubspotUtk).then(function (widgetData) {
      dispatch(receivedWidgetData(widgetData));
    }, function (err) {
      dispatch(requestedWidgetFailed(id, err));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/WidgetActions.js
// module id = 122
// module chunks = 0 1